import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcelService } from 'src/app/services/excel.service';
import { EnderecoService } from 'src/app/services/http/endereco.service';
import { HgService } from 'src/app/services/http/hg.service';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-modal-upload-lote',
  templateUrl: './modal-upload-lote.component.html',
  styleUrls: ['./modal-upload-lote.component.scss']
})
export class ModalUploadLoteComponent implements OnInit {

  constructor(private excelService: ExcelService,public activeModal: NgbActiveModal, private _hgService: HgService, private modalService: NgbModal, private laudoService: LaudoUnionService, private router: Router, private enderecoService: EnderecoService, private msgService: ModalMsgService, private el: ElementRef) { }

  ngOnInit(): void {
  }

  desejaIntegrar: boolean = false;
  tokenHg: string = null;
  refreshTokenHg: string = null;
  entityHgId: string = null;
  instanceHgId: string = null;
  userHgId: string = null;
  emailHg: string = null;
  senhaHg: string = null;
  isAutenticadoHg: boolean = false;
  dadosIniciaisHg: any = null;
  desabilitaCriar: boolean = false;
  idConsulta: any;
  listaAgendamentos: any[] = [];
  listaAgendamentosJson: any[] = [];
  listaAgendamentosComErro: any[] = [];
  listaAgendamentosSemErro: any[] = [];
  loading: boolean = false;
  finalizado: boolean = false;
  acimaDoLimite: boolean = false;
  file:File;

  onFileChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement && inputElement.files && inputElement.files.length > 0) {
      this.file = inputElement.files[0];
      const fileUploadDiv = this.el.nativeElement.querySelector('.file-upload');
      fileUploadDiv.classList.add('active');
      this.acimaDoLimite = false;
    }
  }

  tratarArquivo(file: File) {
    this.loading = true;
    const reader = new FileReader();

    reader.onload = async (e: any) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const data: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const header = data.shift();

      const filteredData = data.filter(row => row.some(cell => !!cell));

      // Converte os dados em JSON e adiciona à lista de agendamentos
      this.listaAgendamentos = filteredData.map((row) => {
        const agendamento: any = {};
        for (let i = 0; i < header.length; i++) {
          agendamento[header[i]] = row[i];
        }
        return agendamento;
      });

      if (this.listaAgendamentos.length <= 100) {
        await this.salvar(this.listaAgendamentos);
      } else {
        this.acimaDoLimite = true;
      }
    };
    reader.readAsBinaryString(file);
  }

  async salvar(listaAgendamentos) {

   const promises = listaAgendamentos.map(async agendamento => {
      if (agendamento.DesejaIntegrar == 1) {
        await this._hgService
        .autenticarHg(agendamento.emailHg, agendamento.senhaHg)
        .then((dadosAuth) => {
          this.tokenHg = dadosAuth?.auth?.token;
          this.refreshTokenHg = dadosAuth?.auth?.refreshToken;
          this.entityHgId = dadosAuth?.entity?.id;
          this.instanceHgId = dadosAuth?.instance?.id;
          this.userHgId = dadosAuth?.user?.id;
          this.emailHg = agendamento.emailHg;
          this.senhaHg = agendamento.senhaHg;

          this.isAutenticadoHg = true;
          this.desabilitaCriar = false;

          this.dadosIniciaisHg = {
            tokenHg: this.tokenHg,
            refreshTokenHg: this.refreshTokenHg,
            entityHgId: this.entityHgId,
            instanceHgId: this.instanceHgId,
            userHgId: this.userHgId,
            emailHg: this.emailHg,
            senhaHg: this.senhaHg,
          };
        })
        .catch((e) => {
          this.isAutenticadoHg = false;
          this.desabilitaCriar = true;
        });
      } else {
        this.dadosIniciaisHg = null;
      }

      // let jsonVeiculo = {}
      // if (agendamento.Placa != undefined) {
      //  await this.laudoService.getVeiculoPlacaChassi(agendamento.Placa).then((veiculo) => {
      //     jsonVeiculo = {
      //       placa: agendamento.Placa
      //     }
      //   }).catch((e)=>{
      //     console.log('erro', e)
      //   });
      // }

      let jsonEndereco = {}
      if (agendamento.Cep != undefined) {
      await this.enderecoService.pesquisaCEP(agendamento.Cep).then((endereco) => {
         jsonEndereco = {
           cep : agendamento.Cep,
           numero : agendamento.Numero,
           bairro : endereco.bairro,
           logradouro : endereco.rua,
           cidade : endereco.cidade,
           uf : endereco.estado
         }
       }).catch((e)=>{
        console.log('erro', e)
      });
     }
      let jsonVeiculo = {
      placa: agendamento.Placa
      }
      let jsonData = {
            cliente: parseInt(agendamento.ClienteId),
            clienteAvulso: (agendamento.ClienteId == 0),
            endereco: {...jsonEndereco},
            veiculo: {...jsonVeiculo},
            dataCriacao: new Date().toISOString(),
            dataAgendamento: this.formatDate(agendamento.DataAgendamento),
            tipolaudo: parseInt(agendamento.ConfiguracaoId),
            modulo: '',
            periodo: parseInt(agendamento.Periodo),
            telefone1: '',
            telefone2: '',
            telefone3: '',
            unidade: '',
            unidadeRealizadora: parseInt(agendamento.UnidadeId),
            vistoriador: parseInt(agendamento.VistoriadorId),
            hg: agendamento.DesejaIntegrar == 1 ? this.dadosIniciaisHg : null
          };
          return jsonData;
    });

    const listaAgendamentosJson = await Promise.all(promises);

    this.laudoService.salvarAgendamentoLote(JSON.stringify(listaAgendamentosJson)).then( r => {
       console.log(r);
       this.listaAgendamentosComErro = r["com erros"];
       this.listaAgendamentosSemErro = r["sem erros"];
       this.finalizado = true;
       this.acimaDoLimite = false;
    });

  }

  formatDate(date) {
    if (typeof date == 'number') {
      date = this.numeroSerialParaData(date);
    }
      const dataFormatada = this.createDateFromString(date);
      return dataFormatada.toISOString();
  };

  createDateFromString(dateString: string): Date | null {
    const dateParts = dateString.split('/');
    if (dateParts.length !== 3) {
      console.error('A string deve estar no formato dd/MM/yyyy');
      return null;
    }

    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;  // O mês em JavaScript é base 0 (janeiro é 0)
    const year = parseInt(dateParts[2], 10);

    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      console.error('Valores de data inválidos.');
      return null;
    }
    const date = new Date(year, month, day);
    return date;
  }

  numeroSerialParaData(numeroSerial: number): string {
    const dataReferencia = new Date(1900, 0, 1);  // 1 de janeiro de 1900
    const diasAdicionados = Math.floor(numeroSerial) - 2;  // -2 porque o Excel tem uma inconsistência na data de referência
    const dataConvertida = new Date(dataReferencia);
    dataConvertida.setDate(dataReferencia.getDate() + diasAdicionados);

    const dia = dataConvertida.getDate().toString().padStart(2, '0');
    const mes = (dataConvertida.getMonth() + 1).toString().padStart(2, '0');
    const ano = dataConvertida.getFullYear();

    return `${dia}/${mes}/${ano}`;
  }

  baixarExemplo(){
    var exemploExcel = [{
      'ClienteId': '',
      'UnidadeId': '',
      'VistoriadorId': '',
      'ConfiguracaoId': '',
      'Placa': '',
      'DataAgendamento': '',
      'Periodo': '',
      'Cep':'',
      'Numero': '',
      'DesejaIntegrar': '',
      'emailHg': '',
      'senhaHg': ''
    }];
    try{
      this.excelService.exportAsExcelFile(exemploExcel,
          `AgendamentoUnion`
          );
    }catch{
      window.alert('Erro ao exportar arquivo')
    }
  }

}

